module.exports = __webpack_public_path__ + "media/images/other-images/bg-profile-baa9e60e7b97ea3ce0b2dce16da5f28f.png";